module.exports = __webpack_public_path__ + "img/Languages.9ff191a7.svg";